import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {PrivateRoutes} from '../../config/routes';
import {ViewInferenceAppPage} from '../InferenceApp/ViewInferenceAppPage';
import {TestDeployProvider} from '../TestDeployView';
import './InferenceAppWindow.scss';
import {InferenceDetails} from '../ProdDeployView/InferenceDetails/InferenceDetails';

class InferenceAppWindow extends Component {
  getProjectId() {
    return this.props.match.params.projectId;
  }

  render() {
    return (
      <div className="inference-app-window">
        <Switch>
          <Route
            path={PrivateRoutes.VIEW_TEST_INFERENCE_APP}
            render={props => (
              <TestDeployProvider>
                <ViewInferenceAppPage {...props} />
              </TestDeployProvider>
            )}
          />
          <Route
            path={PrivateRoutes.VIEW_DEPLOYMENT_INFERENCE_APP}
            render={props => (
              <TestDeployProvider>
                <ViewInferenceAppPage {...props} />
              </TestDeployProvider>
            )}
          />
          <Route
            path={PrivateRoutes.INFERENCE_APP_DETAILS}
            render={props => <InferenceDetails {...props} />}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

const HOC = connect(mapStateToProps, mapDispatchToProps)(InferenceAppWindow);

export {HOC as InferenceAppWindow};
